import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isNpcEntries: false, loading: false };

export const getNpcEntriesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.GET_NPC_ENTRIES_SUCCESS:
      return { ...state, isNpcEntries: true, response: action.payload?.data, loading: false };
    case npcLogConstant.GET_NPC_ENTRIES_FAILURE:
      // THIN-8233: keep `response` null on failure (never the raw axios error) so consumers that
      // treat it as a list (`response || []` then .map/.filter) don't crash the whole NPC page
      // behind the route ErrorBoundary. The error is preserved separately for optional surfacing.
      return {
        ...state,
        isNpcEntries: false,
        response: null,
        error: action.payload,
        loading: false,
      };
    case npcLogConstant.GET_NPC_ENTRIES_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.GET_NPC_ENTRIES_RESET:
      return initialState;
    default:
      return state;
  }
};
